import React, { useState, useMemo } from 'react'

import { Container, H1, Content, ModalContent, ModalTitle, ModalScrollable } from "./styles";

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ModalApp from '../../components/ModalApp'

import { HiOutlineChevronDown } from 'react-icons/hi'

import Title from "../../components/Title";
import { useApp } from "../../contexts/AppContext";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

export default function Policy() {
  const screenName = useScreenTracking();
  const [open, setOpen] = useState(false);
  const { whitelabel } = useApp();

  const termsPdfUrl =
    typeof whitelabel?.assets?.terms_pdf_url === "string"
      ? whitelabel.assets.terms_pdf_url.trim()
      : "";

  const faqs = useMemo(() => {
    if (!whitelabel?.assets?.faq) return [];
    if (typeof whitelabel?.assets?.faq === "string") {
      try {
        return JSON.parse(whitelabel?.assets?.faq);
      } catch (e) {
        console.error("FAQ inválido no whitelabel", e);
        return [];
      }
    }
    return whitelabel?.assets?.faq;
  }, [whitelabel]);

  const sendFAQAnalytics = (customTitle) => {
    trackClick({
      title: customTitle,
      contentType: "regulamento",
      screenName,
      tagId: tagIdFromLegacySuffix("11"),
    });
  };

  const generateFAQSlug = (question) => {
    return question
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 50);
  };

  const handleAccordionChange = (index, question) => (event, isExpanded) => {
    const questionSlug = generateFAQSlug(question);
    
    if (isExpanded) {
      sendFAQAnalytics(`abriu-${index + 1}-${questionSlug}`);
    } else {
      sendFAQAnalytics(`fechou-${index + 1}-${questionSlug}`);
    }
  };

  const handleOpenModal = () => {
    sendFAQAnalytics("abriu-termos-e-condicoes");
    setOpen(true);
  };

  const handleCloseModal = () => {
    sendFAQAnalytics("fechou-termos-e-condicoes");
    setOpen(false);
  };

  const handleDownloadRegulamento = () => {
    sendFAQAnalytics("download-regulamento");
  };

  return (
    <>
      <Container className="wl-page">
        <div
          style={{ display: "flex", justifyContent: "left", marginTop: "1rem" }}
        >
          <Title label={"FAQ"} />
        </div>
        <Content style={{ borderBottom: "1px solid #dee2e6", paddingBottom: ".4rem" }}>
          {faqs.map((item, index) => (
            <React.Fragment key={index}>
              <Accordion 
                sx={{ boxShadow: 0, paddingBottom: "1rem" }} 
                className="accordion"
                onChange={handleAccordionChange(index, item.question)}
              >
                <AccordionSummary
                  expandIcon={<HiOutlineChevronDown size={20} />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                  className="p-0"
                >
                  <span className="text-mg font-wl-500" style={{ color: whitelabel?.theme?.text_primary_color }}>
                    {index + 1}. {item.question}
                  </span>
                </AccordionSummary>
                <AccordionDetails className="pt-0 subcategories">
                  <li className="list-unstyled font-wl-600 color-text-dark">
                    <aside
                      style={{
                        color: whitelabel?.theme?.text_primary_color,
                        opacity: 0.6,
                      }}
                      className="font-wl-400"
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  </li>
                </AccordionDetails>
              </Accordion>
            </React.Fragment>
          ))}
        </Content>
        {termsPdfUrl ? (
          <>
            <div className="font-wl-400" style={{ color: whitelabel?.theme?.text_primary_color }}>
              <span style={{ opacity: 0.6 }}>Para consultar os termos e condições</span>{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenModal();
                }}
                style={{ color: whitelabel?.theme?.text_primary_color, fontWeight: 600 }}
              >
                clique aqui.
              </a>{" "}
              <span style={{ opacity: 0.6 }}>Você também pode fazer o download do regulamento</span>
              {" "}
              <a
                href={termsPdfUrl}
                download
                style={{ color: whitelabel?.theme?.text_primary_color, fontWeight: 600 }}
                onClick={handleDownloadRegulamento}
              >
                clicando aqui.
              </a>
            </div>
          </>
        ) : null}
      </Container>

      <ModalApp show={open} handleModal={handleCloseModal}>
        <ModalContent style={{ alignItems: "center", justifyContent: "center"}}>
          <ModalTitle style={{ color: whitelabel?.theme?.text_primary_color, fontSize: "20px", fontWeight: 500 }}>Termos e condições</ModalTitle>
          <ModalScrollable style={{ padding: 0, display: "flex", flexDirection: "column", alignItems: "center" }}>
            <iframe
              src={termsPdfUrl}
              style={{
                width: "100%",
                height: "450px",
                border: "none",
                borderRadius: "4px"
              }}
              title="Regulamento PDF"
            />
          </ModalScrollable>
          <button className='btn-default-wl' style={{ width: "180px", height: "40px", fontSize: "14px", fontWeight: 600 }} onClick={handleCloseModal}>FECHAR</button>
        </ModalContent>
      </ModalApp>
    </>
  );
}
